export type AssetSelectionInput = {
  selection: Set<string>
  anchorId: string | null
  clickedId: string
  orderedIds: string[]
  additive: boolean
  range: boolean
}

export type MarqueeRect = { left: number; top: number; right: number; bottom: number }

/** Ids of tiles whose rect intersects the marquee rect (all in the same coordinate space). */
export function idsIntersectingRect(rect: MarqueeRect, tiles: Array<{ id: string } & MarqueeRect>): string[] {
  return tiles
    .filter(t => t.left < rect.right && t.right > rect.left && t.top < rect.bottom && t.bottom > rect.top)
    .map(t => t.id)
}

export function nextAssetSelection({
  selection,
  anchorId,
  clickedId,
  orderedIds,
  additive,
  range,
}: AssetSelectionInput): { selection: Set<string>; anchorId: string } {
  if (range && anchorId) {
    const anchorIndex = orderedIds.indexOf(anchorId)
    const clickedIndex = orderedIds.indexOf(clickedId)
    if (anchorIndex >= 0 && clickedIndex >= 0) {
      const start = Math.min(anchorIndex, clickedIndex)
      const end = Math.max(anchorIndex, clickedIndex)
      const next = additive ? new Set(selection) : new Set<string>()
      orderedIds.slice(start, end + 1).forEach(id => next.add(id))
      return { selection: next, anchorId }
    }
  }

  if (additive) {
    const next = new Set(selection)
    if (next.has(clickedId)) next.delete(clickedId)
    else next.add(clickedId)
    return { selection: next, anchorId: clickedId }
  }

  return { selection: new Set([clickedId]), anchorId: clickedId }
}
